import $ from 'cash-dom'

export function lockScroll() {
  $('body').css('overflow', 'hidden')
}

export function unlockScroll() {
  $('body').css('overflow', '')
}
